import { Form } from '@/shared/ui'

type Props = {
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
}

export const PasswordConfirmField = ({
  placeholder,
  readOnly = false,
  disabled = false,
}: Props) => {
  return (
    <Form.Field name="passwordConfirm" readOnly={readOnly} disabled={disabled}>
      <Form.Label className="font-medium text-black">비밀번호 확인</Form.Label>
      <Form.PasswordField
        placeholder={placeholder || '비밀번호를 재입력 해주세요'}
        fullWidth
        readOnly={readOnly}
        autoComplete="new-password"
      />
      <Form.Message />
    </Form.Field>
  )
}
